import store from 'store';
import axios from 'axios';
import router from '../../router';

const state = {
  dispatchUser: {},
  token: '',
  unreadNotifications: 0,
};

const getters = {
  userData: st => st.dispatchUser,
};

const mutations = {
  setUser: (st, payload) => {
    st.dispatchUser = payload;
  },
  setToken: (st, payload) => {
    st.token = payload;
  },
  setUnreadNotifications: (st, payload) => {
    st.unreadNotifications = payload;
  },
  increaseUnreadNotifications: st => {
    st.unreadNotifications += 1;
  },
  markAllNotificationsAsRead: st => {
    st.unreadNotifications = 0;
  },
  markOneAsRead: st => {
    if (st.unreadNotifications >= 0) {
      st.unreadNotifications -= 1;
    }
  },
};

const actions = {
  authLogin: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/login', payload)
        .then(res => {
          dispatch('authSetData', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  authLogout: ({ commit }) => {
    axios.post('/logout');
    commit('setUser', {});
    commit('setToken', '');
    commit('setUnreadNotifications', 0);
    commit('setPermissions', []);
    store.remove('dispatchUser');
    store.remove('jwtToken');
    store.remove('permissions');
    store.remove('unreadNotifications');
  },
  authRefresh({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('clusters/users/me')
        .then(res => {
          commit('setUser', res.data.data);
          store.set('dispatchUser', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  authSetData: ({ commit, dispatch }, { user, token }) => {
    commit('setUser', user);
    commit('setToken', token);
    store.set('dispatchUser', user);
    store.set('jwtToken', token);
    window.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    window.echo.connector.options.auth.headers.Authorization = `Bearer ${token}`;
    window.echo.private(`App.Models.User.${user.id}`).notification(() => {
      commit('increaseUnreadNotifications');
    });
    if (user.phone_verified) {
      dispatch('getPermissions', user);
      axios.get('/clusters/users/notifications').then(res => {
        if (res.data.length) {
          commit('setUnreadNotifications', res.data.length);
        }
      });
    }
  },
  getAuthFromStorage({ commit, dispatch }) {
    if (store.get('dispatchUser') && store.get('jwtToken')) {
      const user = store.get('dispatchUser');
      const token = store.get('jwtToken');
      dispatch('authSetData', { user, token });
      if (store.get('dispatchUser').phone_verified && !store.get('permissions')) {
        dispatch('getPermissions', store.get('dispatchUser'));
      }
    } else {
      commit('setUser', {});
      commit('setToken', '');
      store.remove('dispatchUser');
      store.remove('jwtToken');
      store.remove('permissions');
      const meta = router.currentRoute.meta.requiresAuth;
      if (meta) {
        router.push('/login');
      }
    }
  },
  sendMailForResetPassword: (context, user) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/password/email', user)
        .then(() => {
          // commit('resetPasswordSetData', res.data.data)
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  setNewPassword: (context, user) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/password/reset', user)
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js